import { gql } from '@apollo/client'
export const UPSERT_FINE = gql`
  mutation UpsertFine($data: FineInput!) {
  upsertFine(fine: $data)  
}
`